export enum LoungeActionConstants {
  UPLOAD = 'UPLOAD',// Suivi de sinistre onglet Upload
  FOLLOW = 'FOLLOW',// Suivi de sinistre
  NONE = 'NONE',// Page d’accueil de l’espace assuré
  CONTRACTS = 'CONTRACTS',// Liste des adhésions 
  CONTRACT = 'CONTRACT',// Consulte l'adhésion
  CONTACT_US = 'CONTACT_US',// Page contactez nous avec les choix de contact
  CONTACT_FORM = 'CONTACT_FORM',// Formulaire de contact
}
